const svgArrow =
  '<svg class="carousel-pfeil" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.88 22.35"><path d="M62.68.46h0a1.44,1.44,0,0,0,.07,2h0l7.77,7.23H1.44a1.44,1.44,0,1,0,0,2.87H70.53l-7.77,7.23A1.43,1.43,0,0,0,64.62,22l.09-.08L75.59,11.8a.89.89,0,0,0,0-1.26l0,0L64.71.38a1.44,1.44,0,0,0-2,.08"/></svg>';

jQuery(document).ready(function ($) {
  class HomeHeaderCarousel {
    constructor(carousel) {
      this.$homeHeaderCarousel = $(carousel);

      this.$progressBar = $(".home-header__initProgressBar");
      this.$bar = $(".home-header__bar");
      this.autoplayDelay = 7;

      this._initCarousel();
    }

    _initCarousel() {
      this.carousel = this.$homeHeaderCarousel.owlCarousel({
        items: 1,
        loop: true,
        dots: true,
        nav: true,
        autoplay: true,
        autoplayTimeout: this.autoplayDelay * 1000,
        navText: [svgArrow, svgArrow],
        onInitialize: this._initProgressBar.bind(this),
      });

      this.carousel.on(
        "changed.owl.carousel",
        this._handleCarouselChange.bind(this)
      );
    }

    _handleCarouselChange(evt) {
      var current_slide_in_loop =
        evt.page.index - evt.relatedTarget._clones.length / 2 + 2;
      this._setActiveText(current_slide_in_loop);
      this._resetProgressBar();
    }

    _setActiveText(index) {
      $(".home-header__text.active").removeClass("active");
      $('.home-header__text[data-index="' + index + '"]').addClass("active");
    }

    // Progress Bar
    _initProgressBar(elem) {
      this._start();
    }

    _start() {
      this.$bar.css({
        width: 0 + "%",
      });
      this.percentTime = 0;
      this.isPause = false;
      this.tick = setInterval(this._interval.bind(this), 10);
    }

    _interval() {
      if (this.isPause === false) {
        this.percentTime += 1 / this.autoplayDelay;
        this.$bar.css({
          width: this.percentTime + "%",
        });
      }
    }

    _pauseOnDragging() {
      this.isPause = true;
    }

    _resetProgressBar() {
      this.carousel.trigger("stop.owl.autoplay");
      this.carousel.trigger("play.owl.autoplay");
      clearTimeout(this.tick);
      this._start();
    }
  }

  window.luther = window.luther || {};
  window.luther.homeHeaderCarousels = [];

  window.$(".home-header__images").each((i, el) => {
    let homeHeaderCarousel = new HomeHeaderCarousel(el);
    window.luther.homeHeaderCarousels.push(homeHeaderCarousel);
  });
});
